import { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';
import { Box, Breakpoint, Container, styled } from '@mui/material';

const PageTitle = styled(Box)(
  ({ theme }) => `
        padding: ${theme.spacing(4)};
`
);

interface PageTitleWrapperProps {
  children?: ReactNode;
  maxWidth?: Breakpoint
}

const PageTitleWrapper: FC<PageTitleWrapperProps> = ({ children, maxWidth = 'lg' }) => {
  return (
    <PageTitle className="MuiPageTitle-wrapper">
      <Container maxWidth={maxWidth}>{children}</Container>
    </PageTitle>
  );
};

PageTitleWrapper.propTypes = {
  children: PropTypes.node.isRequired
};

export default PageTitleWrapper;
